/* eslint-disable react/require-default-props */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import './index.css';
import warn from '../../constants/toast';

interface Props {
  style?: any;
  onChange: any;
  onChangeFileName: any;
  disabled: boolean;
  id?: string;
}

const InputFile: React.FC<Props> = ({
  style, onChange, onChangeFileName, disabled, id,
}) => {
  const onFileChange = (event: any) => {
    const reader = new FileReader();
    const file = event.target.files[0];

    reader.onloadend = () => {
      if ((file?.size / 1024) > 200) {
        warn.wargingInfo('A imagem seleciona é muito grande, redimensione sua imagem para 200 KB!');
      } else {
        onChange(reader.result);
        onChangeFileName(file.name);
      }
    };
    reader.readAsDataURL(file);
  };
  return (
    <div style={style}>
      <input disabled={disabled} type="file" accept="image/*" name="file" id={id || 'file'} onChange={onFileChange} />
    </div>
  );
};

export default InputFile;
